import { memo, useState, useEffect } from 'react'

import { Box, Flex, Tooltip } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { displayReactIcon } from '../helpers/dsr-display-helpers';

import { RiQuestionFill } from 'react-icons/ri'
import LaunchdeckBrandingLabel from '../../global/components/product-marketing/LaunchdeckBrandingLabel'

function DsrProspectSideMenu({
  pageArray,
  selectedDisplaySubpage,
  selectedDisplayPageId,
  extraHeaderLayoutOffset,
  handleSelectSubpage,
  headerMenuHeight,
  isDsrAdmin,
  closeMenuDrawer,
  dsrBrandingOptions,
  applyBranding,
  isMobileView
}) {

  const [brandColor, setBrandColor] = useState(null);

  useEffect(() => {
    if (dsrBrandingOptions) {
      const {primaryColor} = dsrBrandingOptions || {}
      setBrandColor(primaryColor)
    }
  }, [dsrBrandingOptions]);

  function renderSubPageTabs(category) {
    if (!pageArray) {
      return null
    }

    let pagesToRender = [];

    if (category === 'essential-pages') {
      pagesToRender = pageArray?.filter(tabs => tabs.pageType !== 'customised-page')
    } else if (category === 'custom-pages') {
      pagesToRender = pageArray?.filter(tabs => tabs.pageType === 'customised-page')
    }

    if (pagesToRender) {
      const pageTabs = pagesToRender?.map((tabs, tabIndex) => {
        const { pageId, pageIcon, pageIconColor, pageTitle, pageType, displayPage, lockedPage } = tabs || {};

        const displayIcon = pageIcon ? pageIcon : pageType
        const displayIconColor = (applyBranding && brandColor) ? brandColor : pageIconColor ? pageIconColor : 'brandDark.500';

        if (displayPage === true) {
          if (pageType === 'customised-page') {
            if (lockedPage) {
              return (
                <Flex key={`dsr_page_tab_${tabIndex}-${pageId}`} justify='flex-start' align='center' px='1.1em' py='0.875em'
                  className="locked-subpage"
                >
                  <Flex justify='flex-start' align='center' gap='1em'>
                    <Box>{displayReactIcon("lock", '1em', displayPage)}</Box>
                    <Box whiteSpace='pre-wrap' minW='11em'>{pageTitle}</Box>
                  </Flex>
                </Flex>
              )
            } else {
   

            return (
              <Flex key={`dsr_page_tab_${tabIndex}-${pageId}`} justify='flex-start' align='center' px='1.1em' py='0.875em'
                className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
                onClick={() => {
                  handleSelectSubpage(pageId, "")
                  closeMenuDrawer && closeMenuDrawer()
                }}
              >

                <Flex justify='flex-start' align='flex-start'>
                <Box mt='0.3em' color={displayIconColor}>{displayReactIcon(displayIcon, '1em', displayPage)}</Box>
                  <Box whiteSpace='pre-wrap' minW='11em' ml='1em'>{pageTitle}</Box>
                </Flex>
              </Flex>
            )
          }
          } else {
            return (
              <Flex key={`dsr_page_tab_${tabIndex}-${pageId}`} justify='flex-start' align='center' px='1.1em' py='0.875em'
                className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
                onClick={() => {
                  handleSelectSubpage(pageId, "")
                  closeMenuDrawer && closeMenuDrawer()
                }}
              >
                <Box color={displayIconColor}>
                  {displayReactIcon(displayIcon, '1em')}
                </Box>
                <Box>{pageTitle}</Box>
              </Flex>
            )
          }
        } else {
          return (
            <Flex
              justify='flex-start' align='center' px='1.1em' py='0.875em'
              className="unchosen-subpage-option"
              w='100%'
            />
          )
        }
      }
      )

      return (
        <>
        <Box data-driver="prospector-tour-step-4">
          {pageTabs}
          </Box>
        </>
      )

    }

    else return null


  }

  const categoryLabel = (labelText, toolTipText) => {
    return (
      <Flex mt='1em' justify='flex-start' align='center' color='gray.500' cursor='default' className='unchosen-subpage-option'>
        <Box fontSize='0.75em' fontWeight='600' whiteSpace='pre'>{labelText}</Box>
        <Tooltip fontSize='0.8em' label={toolTipText} placement="auto-start">
          <Box ml='0.5em'>
            <Box as={RiQuestionFill} boxSize="1em" py='3%' />
          </Box>
        </Tooltip>
      </Flex>
    )
  }

  const renderAdminPageTabs = () => {
    return (
      <Box mt='3em'>
        {categoryLabel('ADMINISTRATOR PAGES', 'Info accessible only by you')}

        {/* TODO: Analytics for Prospect DSRs */}
        {/* <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "insights-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'insights-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
        >
          <Box fill="gray.300">{displayReactIcon('worktool', '1em')}</Box>
          <Box lineHeight='1.5em' ml='1em' color='gray.500'> Insights</Box>
        </Flex> */}

        <Flex justify='flex-start' align='center' px='1.1em' py='1em'
          className={(selectedDisplaySubpage === "prospector-team-notes-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'prospector-team-notes-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Team Notes</Box>

        </Flex>

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "prospect-room-settings-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'prospect-room-settings-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Settings </Box>
        </Flex>

      </Box>
    )
  }

  return (
    <Flex
      flexWrap='wrap'
      justify='flex-start'
      pt={extraHeaderLayoutOffset ? '3em' : '2em'}
      maxWidth='280px'
      height={`calc(100vh - ${headerMenuHeight})`}
      overflowX="hidden"
      overflowY="auto"
      sx={{
        // Hides scrollerbar
        '&::-webkit-scrollbar': { display: 'none' },  // Chrome, Safari, Opera
        '-ms-overflow-style': 'none',                 // IE and Edge
        'scrollbar-width': 'none',                    // Firefox
      }}
    >
      <Flex direction='column' justify='space-between' align='flex-start' maxWidth='fit-content'  pb='1em'>
        <Box>
          {renderSubPageTabs('custom-pages')}
        </Box>

        <>
          <Box>
            {(isDsrAdmin && !isMobileView) &&
              <>
                {renderAdminPageTabs()}
              </>
            }
          </Box>
          <LaunchdeckBrandingLabel />
        </>
      </Flex>

    </Flex>
  )
}

const mapStateToProps = (state) => {
  return {
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    isMobileView: state.mobileViewMode.isMobileView,
    showLaunchdeckBranding: state.showLaunchdeckBranding.results
  }
}


export default memo(withRouter(connect(mapStateToProps, null)(DsrProspectSideMenu)))

